'use client';

import { useSessionIdSync } from '@/lib/analytics/client/hooks/useSessionIdSync';
export function SessionIdSyncProvider() {
  useSessionIdSync();
  return null;
}